import { CogIcon, DropletsIcon, FilterIcon, GaugeIcon, WindIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Fluid Power Fundamentals: Principles, Components & Circuit Symbols',
    summary: 'Pressure, flow and force, Pascal’s law, hydraulic vs pneumatic systems, the building blocks of every circuit, ISO 1219 symbols and the core calculations.',
    icon: GaugeIcon,
  },
  {
    number: '02',
    title: 'Hydraulic Pumps, Motors, Cylinders & Power Units',
    summary: 'Gear, vane and piston pumps, pump controls, cavitation and aeration, hydraulic motors, cylinders and seals, power units, coolers and accumulators.',
    icon: CogIcon,
  },
  {
    number: '03',
    title: 'Hydraulic Valves & Circuit Design',
    summary: 'Directional, pressure and flow control valves, cartridge and manifold systems, load-holding and counterbalance valves, and how to read and build complete circuits.',
    icon: DropletsIcon,
  },
  {
    number: '04',
    title: 'Hydraulic Fluids, Filtration & Contamination Control',
    summary: 'Fluid types and properties, viscosity, ISO 4406 cleanliness codes, filter selection and placement, oil analysis and contamination prevention.',
    icon: FilterIcon,
  },
  {
    number: '05',
    title: 'Pneumatic Systems: Compressed Air, Valves & Actuators',
    summary: 'Compressors, air treatment and distribution, FRL units, pneumatic valves, cylinders and grippers, vacuum and basic pneumatic circuits.',
    icon: WindIcon,
  },
  {
    number: '06',
    title: 'Maintenance, Troubleshooting & Safety',
    summary: 'Preventive maintenance routines, systematic fault-finding, pressure and flow testing, hose management, lockout and zero-energy procedures.',
    icon: WrenchIcon,
  },
];
